import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Icon, Loader, Pagination } from "semantic-ui-react";
import "./Reminders.css";
import Filter from "../../components/layout/Reminders/Filter";
import Add from "../../components/layout/Reminders/Add";
import Card from "../../components/layout/Reminders/Card";

const SuperReminders = (props) => {
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [add, setAdd] = useState(false);
  const [reminders, setReminders] = useState([]);
  const [sports, setSports] = useState([]);
  const [classYears, setClassYears] = useState([]);
  const [sport, setSport] = useState(null);
  const [classYear, setClassYear] = useState(null);
  const [commitment, setCommitment] = useState(null);
  const handleSearch = () => {};

  const pageChange = (not, data) => {
    setActivePage(data.activePage);
  };

  useEffect(() => {
    if (
      props.reminders &&
      props.athletes &&
      props.reminders.length > 0 &&
      Object.keys(props.athletes).length > 0
    ) {
      let sportsData = [];
      let classYearData = [];
      const reminders = [...props.reminders];
      const athletes = { ...props.athletes };
      const advocates = { ...props.advocates };
      let savingData = reminders.map((reminder) => {
        const arrayOfAthletes = [...reminder.athletes];

        const athletesData = arrayOfAthletes.map((athlete) => {
          const id = athlete.id;
          if (athletes[id]) {
            sportsData.push(athletes[id]?.sport);
            classYearData.push(athletes[id]?.class);
            return { ...athletes[id], ...athlete };
          }
          if (advocates[id]) {
            return { ...advocates[id], ...athlete };
          }
        });

        return { ...reminder, athletes: athletesData };
      });
      if (sport) {
        savingData = savingData.map((reminder) => {
          const arrayOfAthletes = [...reminder.athletes];
          const athletesData = arrayOfAthletes.map((athlete) => {
            const athleteSport = athlete?.sport;
            if (athleteSport === sport) {
              return { ...athlete };
            }
          });
          return { ...reminder, athletes: athletesData.filter((a) => a) };
        });
      }
      if (classYear) {
        savingData = savingData.map((reminder) => {
          const arrayOfAthletes = [...reminder.athletes];
          const athletesData = arrayOfAthletes.map((athlete) => {
            const athleteClass = athlete?.class;
            if (athleteClass === classYear) {
              return { ...athlete };
            }
          });
          return { ...reminder, athletes: athletesData.filter((a) => a) };
        });
      }
      if (commitment === false || commitment === true) {
        savingData = savingData.map((reminder) => {
          const arrayOfAthletes = [...reminder.athletes];
          const athletesData = arrayOfAthletes.map((athlete) => {
            const athleteCommit = athlete.committed;
            if (athleteCommit === commitment) {
              return { ...athlete };
            }
          });
          return { ...reminder, athletes: athletesData.filter((a) => a) };
        });
      }
      savingData = savingData.filter((a) => a.athletes.length > 0);

      // Sports
      sportsData = [...new Set(sportsData)];
      sportsData = sportsData.sort((a, b) => a - b);
      sportsData = sportsData.map((e, i) => {
        return { key: i, text: e, value: e };
      });
      setSports(sportsData);

      // Class Year
      classYearData = [...new Set(classYearData)];
      classYearData = classYearData.sort((a, b) => a - b);
      classYearData = classYearData.map((e, i) => {
        return {
          key: i,
          text: e !== `college_transfer` ? e : "College Transfer",
          value: e,
        };
      });
      setClassYears(classYearData);

      // Setting Reminders
      const paginated =
        savingData && savingData.slice((activePage - 1) * 9, activePage * 9);
      setTotalPages(Math.ceil(savingData.length / 9));
      setReminders(paginated);
    } else {
      setReminders([]);
      setSports([]);
      setClassYears([]);
    }
  }, [
    props.reminders,
    props.athletes,
    props.advocates,
    sport,
    classYear,
    commitment,
    activePage,
  ]);

  if (!props.auth.isLoaded) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else if (
    props.auth.isLoaded &&
    (props.auth.email === "csanicknaudin@gmail.com" || props.superAdmin)
  ) {
    if (props.auth.isLoaded) {
      return (
        <>
          <div className="AthleteDetailsBackground cu-profile new-signup-container">
            <div className="AthleteDetailsBannerBar"></div>
            <Filter
              onChange={() => setActivePage(1)}
              superAdmin={true}
              searchQuery={handleSearch}
              sports={sports}
              classYears={classYears}
              sport={(sp) => setSport(sp)}
              classYear={(cy) => setClassYear(cy)}
              commitment={(commit) => setCommitment(commit)}
            />
            <div className="AddAthleteButtonContainer">
              <Button
                color="green"
                icon="plus square"
                labelPosition="left"
                name="editedButton"
                onClick={() => setAdd(true)}
                content="New Reminder"
              />
            </div>
          </div>
          <div className="custom-bg">
            <div className="AthleteEventsInfoContainer common-event">
              <div
                className={`AthleteEventsGroupContainer ${
                  reminders &&
                  reminders.length > 0 &&
                  (reminders.length === 1
                    ? "onlyone"
                    : reminders.length === 2
                    ? "onlytwo"
                    : "")
                }`}
              >
                {reminders &&
                  reminders.length > 0 &&
                  reminders.map((reminder, key) => (
                    <Card key={key} reminder={reminder} />
                  ))}
              </div>
              {reminders && reminders.length < 1 && (
                <p className="not-found cu-center">There's No Data Right Now</p>
              )}
            </div>
            {totalPages > 1 && (
              <div className="AthleteSearchDetail AthletePagination justify-center">
                <Pagination
                  onPageChange={pageChange}
                  activePage={activePage}
                  firstItem={null}
                  lastItem={null}
                  prevItem={{ content: <Icon name="angle left" />, icon: true }}
                  nextItem={{
                    content: <Icon name="angle right" />,
                    icon: true,
                  }}
                  pointing
                  secondary
                  totalPages={totalPages}
                />
              </div>
            )}
          </div>
          <Add open={add} close={() => setAdd(false)} />
        </>
      );
    } else
      return (
        <div className="SpinnerBackground">
          <div className="SpinnerContainer">
            <Loader size="large" active inline="centered" />
          </div>
        </div>
      );
  } else if (props.auth.isLoaded && !props.auth.email) {
    return <Redirect to={`/login`} />;
  } else if (
    props.auth.isLoaded &&
    props.auth.email &&
    (props.auth.email !== "csanicknaudin@gmail.com" || props.superAdmin)
  ) {
    return <Redirect to={`/events`} />;
  }
  return null;
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    reminders: state.firestore.ordered.reminders,
    athletes: state.firestore.data.adminAthletes,
    advocates: state.firestore.data.advocates,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "reminders",
      orderBy: ["modifiedAt", "desc"],
    },
    {
      collection: "adminAthletes",
      where: ["profilePublic", "==", true],
      orderBy: ["lastName", "asc"],
    },
    {
      collection: "advocates",
    },
  ])
)(SuperReminders);
